export default "__VITE_ASSET__CAb0dAJ5__"